module.exports = __webpack_public_path__ + "static/media/art-of-war.367c1286.jpg";